import axios from 'axios';
import baseUrl from '../config/baseURL';
import { getAuthToken } from '../services/auth';
import { LeadPatch } from '../pages/EditLeadDetailsPage';
import { CatalogueItem, Lead } from '../utils/types';

export const addCatalogueItemByText = async (
  orgId: string,
  context: string,
) => {
  const product_context = {
    context,
  };
  let token = await getAuthToken();
  let headers;

  if (token) {
    let header_token = 'Bearer ' + token.data;
    headers = {
      Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/generate-product-details/from_text/`;
    const response = await axios.post(endpoint, product_context, { headers });

    console.log('response on sending details to back:', response);

    if (response.status >= 200 && response.status <= 400) {
      console.log('Product added successfully:', response.data);
      return { success: true, data: response.data };
    } else {
      console.error('Failed to create lead note:', response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error(
      'An unexpected error occurred:',
      error?.response?.data || error,
    );
    return { success: false, data: error?.response?.data || error };
  }
};

export interface CatalogueItemInput {
  name: string;
  description: string;
  price: number;
}

export const storeItemsToLocal = (leads: CatalogueItem[]) => {
  try {
    localStorage.setItem('catalogue-items', JSON.stringify(leads));
    return true;
  } catch (error) {
    console.error('Failed to store items in localStorage:', error);
    return false;
  }
};

export const getCatalogue = async (organization_id: string) => {
  try {
    const token = await getAuthToken();
    if (!token) {
      return { success: false, data: 'Token not available' };
    }
    const headers = {
      Authorization: `Bearer ${token.data}`,
    };

    const firstPageUrl = `${baseUrl}/core/organizations/${organization_id}/catalogue/`;
    const response = await axios.get(firstPageUrl, { headers });

    if (response.status >= 200 && response.status <= 400) {
      const res = response.data.results[0];

      return { success: true, data: res };
    } else {
      return { success: false, data: response?.data };
    }
  } catch (error) {
    console.error('Error in getting catalogue:', error);
    return { success: false, data: error };
  }
};

export const getCatalogueItems = async (
  organization_id: string,
  catalogue_id: string,
) => {
  console.log('Getting initial items.');

  // const local = getItemsFromLocal(organization_id);
  try {
    const token = await getAuthToken();
    if (!token) {
      return { success: false, data: 'Token not available' };
    }
    const headers = {
      Authorization: `Bearer ${token.data}`,
    };

    const firstPageUrl = `${baseUrl}/core/organizations/${organization_id}/catalogue/${catalogue_id}/catalogue-items`;
    const response = await axios.get(firstPageUrl, { headers });

    if (response.status >= 200 && response.status <= 400) {
      const { count } = response.data;
      console.log('api item count', count);

      if (response.status) {
        return { success: true, data: response.data };
      } else {
        const fullResponse: any = await getCatalogueItems(
          organization_id,
          catalogue_id,
        );

        if (fullResponse.success) {
          storeItemsToLocal(fullResponse.data);
          return { success: true, data: fullResponse.data, source: 'fresh' };
        } else {
          return { success: false, data: fullResponse.data };
        }
      }
    } else {
      return { success: false, data: response?.data };
    }
  } catch (error) {
    console.error('Error in getInitialLeads:', error);
    return { success: false, data: error };
  }
};

export const getCatalogueItem = async (
  organization_id: any,
  catalogue: any,
  item_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/catalogue/${catalogue}/catalogue-items/${item_id}`;
        const response = await axios.get(endpoint, { headers });
        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data retrieval failed here:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('An unexpected error occurred:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred while fetching the item:', error);
    return { success: false, data: undefined };
  }
};

export const deleteCatalogueItem = async (
  organization_id: string,
  item_id: string,
  catalogueId: string,
) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/catalogue/${catalogueId}/catalogue-items/${item_id}/`;
        const response = await axios.delete(endpoint, { headers });
        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data deletion failed here:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('An unexpected error occurred:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred :', error);
    return { success: false, data: undefined };
  }
};

export const saveCatalogueItem = async (
  orgId: string,
  item: CatalogueItemInput,
  catalogueId: string,
): Promise<{ success: boolean; data: any }> => {
  try {
    const token = await getAuthToken();
    const headers = token?.data
      ? { Authorization: `Bearer ${token.data}` }
      : undefined;

    const endpoint = `${baseUrl}/core/organizations/${orgId}/catalogue/${catalogueId}/catalogue-items/`;
    const response = await axios.post(endpoint, item, { headers });

    if (response.status === 201) {
      console.log('Catalogue item created successfully:', response.data);
      return { success: true, data: response.data };
    } else {
      console.error('Failed to create item:', response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    const errorData = error?.response?.data || error.message || 'Unknown error';
    console.error('Unexpected error occurred:', errorData);
    return { success: false, data: errorData };
  }
};

export const updateItemDetail = async (
  orgId: string,
  itemId: any,
  detailName: string,
  detailData: string,
) => {
  const itemData = {
    [detailName]: detailData,
  };

  console.log('data', itemData);
  let token = await getAuthToken();
  let headers;

  if (token) {
    let header_token = 'Bearer ' + token.data;
    headers = {
      Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/catalogue-items/${itemId}/`;
    const response = await axios.patch(endpoint, itemData, { headers });

    if (response.status === 200) {
      console.log('Item data updated successfully:', response.data);

      return { success: true, data: response.data };
    } else {
      console.error('Failed to update item:', response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error(
      'An unexpected error occurred:',
      error?.response?.data || error,
    );
    return { success: false, data: error?.response?.data || error };
  }
};

export const updateItemDetails = async (
  orgId: string,
  itemId: any,
  catalogueId: any,
  detailData: any,
) => {
  const leadData = detailData;

  console.log('data', leadData);
  let token = await getAuthToken();
  let headers;

  if (token) {
    let header_token = 'Bearer ' + token.data;
    headers = {
      Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/catalogue/${catalogueId}/catalogue-items/${itemId}/`;
    const response = await axios.patch(endpoint, leadData, { headers });

    if (response.status === 200) {
      console.log('Item data updated successfully:', response.data);

      return { success: true, data: response.data };
    } else {
      console.error('Error on updating item:', response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error(
      'An unexpected error occurred:',
      error?.response?.data || error,
    );
    return { success: false, data: error?.response?.data || error };
  }
};
